module.exports = __webpack_public_path__ + "img/柱状.6d9861be.png";